import { render, staticRenderFns } from "./AppResult.vue?vue&type=template&id=12825e71&scoped=true&"
import script from "./AppResult.vue?vue&type=script&lang=js&"
export * from "./AppResult.vue?vue&type=script&lang=js&"
import style0 from "./AppResult.vue?vue&type=style&index=0&id=12825e71&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12825e71",
  null
  
)

component.options.__file = "AppResult.vue"
export default component.exports